// Member presence cadence — the one place the client heartbeat, the server
// write throttle, the online and idle windows, and the viewer's re-read
// interval are defined. They only work as a set, so they live together.
//
// The shape follows the common industry pattern (LinkedIn's presence platform,
// Teams, Google Chat, Matrix): a client heartbeat, an online window of one
// interval plus grace, a separate input-idle threshold, and viewers reading
// presence only for the members on their screen.
//
// Timeline for a member with the app open:
//   - The web shell beats on mount, when the tab becomes visible (unless it beat
//     within the THROTTLE), and every HEARTBEAT interval while it stays
//     visible. Hidden tabs do not beat. Each beat reports how long ago the last
//     keyboard / pointer / touch input happened.
//   - The server records the beat in `member_presence`: `last_seen_at` unless
//     the stored value is younger than the THROTTLE, and `last_active_at` from
//     the reported input age (the newest across tabs). The throttle sits below
//     the heartbeat interval so every on-cadence beat lands (15s of slack
//     absorbs timer drift and request latency), while bursts collapse.
//   - A member reads as online while `last_seen_at` is inside the ONLINE window
//     and `last_active_at` is inside the IDLE window. The ONLINE window is three
//     intervals, so two lost beats (network blip, laptop waking) don't drop the
//     dot; a member who closes or hides the app reads as offline at most ONLINE
//     window + POLL interval later. A member who leaves a visible tab untouched
//     reads as offline once IDLE passes, within one POLL.
//   - Viewers re-read their peers' presence every POLL interval while visible,
//     so a peer coming online shows up within one heartbeat plus one poll.
export const PRESENCE_HEARTBEAT_INTERVAL_MS = 60_000;
export const PRESENCE_WRITE_THROTTLE_MS = 45_000;
export const PRESENCE_ONLINE_WINDOW_MS = 180_000;
export const PRESENCE_IDLE_AFTER_MS = 300_000;
export const PRESENCE_POLL_INTERVAL_MS = 60_000;
// Most member ids one presence read may ask about. The server rejects larger
// requests; the web client splits a bigger subscription into reads of this size.
export const PRESENCE_LOOKUP_MAX_IDS = 100;
//# sourceMappingURL=presence.js.map